export default {
    ABORTO_ESPONTANEO: 'O03',
    ABORTO_NAO_ESPECIFICADO: 'O06',
    ABORTO_POR_RAZOES_MEDICAS_E_LEGAIS: 'O04',
    ANORMALIDADES_DA_CONTRACAO_UTERINA: 'O62',
    ASSISTENCIA_E_EXAME_POS_NATAL: 'Z39',
    CHOQUE_DURANTE_OU_SUBSEQUENTE_AO_TRABALHO_DE_PARTO_E_O_PARTO: 'O751',
    COMPLICACOES_DO_TRABALHO_DE_PARTO_E_DO_PARTO_NAO_ESPECIFICADAS: 'O759',
    DEMORA_DO_PARTO_APOS_RUPTURA_ARTIFICIAL_DAS_MEMBRANAS: 'O755',
    DEMORA_DO_PARTO_APOS_RUPTURA_ESPONTANEA_OU_NAO_ESPECIFICADA_DAS_MEMBRANAS: 'O756',
    DESCOLAMENTO_PREMATURO_DA_PLACENTA_ABRUPTIO_PLACENTAE: 'O45',
    EXAME_DE_ROTINA_DE_SAUDE_DA_CRIANCA: 'Z001',
    EXTRACAO_MENSTRUAL: 'Z303',
    FALHA_NA_INDUCAO_DO_TRABALHO_DE_PARTO: 'O61',
    LACERACAO_DO_PERINEO_DURANTE_O_PARTO: 'O70',
    NASCIDOS_VIVOS_SEGUNDO_O_LOCAL_DE_NASCIMENTO: 'Z38',
    NASCIMENTO_GEMELAR_GEMEOS_AMBOS_NATIVIVOS_NADO_VIVOS: 'Z372',
    NASCIMENTO_GEMELAR_GEMEOS_NATIMORTOS_FETO_MORTOS: 'Z374',
    NASCIMENTO_GEMELAR_UM_DOS_GEMEOS_NATIVIVO_NADO_VIVO_O_OUTRO_NATIMORTO_FETO_MORTO: 'Z373',
    NASCIMENTO_NAO_ESPECIFICADO: 'Z379',
    NASCIMENTO_UNICO_NATIMORTO_FETO_MORTO: 'Z371',
    NASCIMENTO_UNICO_NATIVIVO_NADO_VIVO: 'Z370',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_ANORMALIDADE_PELVICA_DA_MAE: 'O65',
    OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_MA_POSICAO_OU_MA_APRESENTACAO_DO_FETO: 'O64',
    OUTRAS_COMPLICACOES_DE_PROCEDIMENTOS_OU_DE_CIRURGIA_OBSTETRICA: 'O754',
    OUTRAS_COMPLICACOES_ESPECIFICADAS_DO_TRABALHO_DE_PARTO_E_DO_PARTO: 'O758',
    OUTRAS_FORMAS_DE_OBSTRUCAO_DO_TRABALHO_DE_PARTO: 'O66',
    OUTROS_NASCIMENTOS_MULTIPLOS_ALGUNS_NATIVIVOS_NADO_VIVOS: 'Z376',
    OUTROS_NASCIMENTOS_MULTIPLOS_TODOS_NATIMORTOS_FETO_MORTOS: 'Z377',
    OUTROS_NASCIMENTOS_MULTIPLOS_TODOS_NATIVIVOS_NADO_VIVOS: 'Z375',
    OUTROS_PRODUTOS_ANORMAIS_DA_CONCEPCAO: 'O02',
    OUTROS_TIPOS_DE_ABORTO: 'O05',
    OUTROS_TIPOS_DE_PARTO_UNICO_ASSISTIDO: 'O83',
    OUTROS_TRAUMATISMOS_OBSTETRICOS: 'O71',
    PARTO_MULTIPLO: 'O84',
    PARTO_UNICO_ESPONTANEO: 'O80',
    PARTO_UNICO_POR_CESARIANA: 'O82',
    PARTO_UNICO_POR_FORCEPS_OU_VACUO_EXTRATOR: 'O81',
    PARTO_VAGINAL_SUBSEQUENTE_A_CESARIANA_ANTERIOR: 'O757',
    RETENCAO_DA_PLACENTA_E_DAS_MEMBRANAS_SEM_HEMORRAGIAS: 'O73',
    RUPTURA_PREMATURA_DE_MEMBRANAS: 'O42',
    SOFRIMENTO_MATERNO_DURANTE_O_TRABALHO_DE_PARTO_E_O_PARTO: 'O750',
    SUPERVISAO_DE_GRAVIDEZ_COM_GRANDE_MULTIPARIDADE: 'Z354',
    SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ABORTO: 'Z351',
    SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ASSISTENCIA_PRE_NATAL_INSUFICIENTE: 'Z353',
    SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ESTERILIDADE: 'Z350',
    SUPERVISAO_DE_GRAVIDEZ_COM_OUTROS_ANTECEDENTES_DE_PROCRIACAO_PROBLEMATICA: 'Z352',
    SUPERVISAO_DE_GRAVIDEZ_DE_ALTO_RISCO: 'Z35',
    SUPERVISAO_DE_GRAVIDEZ_DE_ALTO_RISCO_DEVIDO_A_PROBLEMAS_SOCIAIS: 'Z357',
    SUPERVISAO_DE_GRAVIDEZ_NORMAL: 'Z34',
    SUPERVISAO_DE_GRAVIDEZ_NORMAL_NAO_ESPECIFICADA: 'Z349',
    SUPERVISAO_DE_OUTRAS_GRAVIDEZES_DE_ALTO_RISCO: 'Z358',
    SUPERVISAO_DE_OUTRA_GRAVIDEZ_NORMAL: 'Z348',
    SUPERVISAO_DE_PRIMEIRA_GRAVIDEZ_NORMAL: 'Z340',
    SUPERVISAO_DE_PRIMIGESTA_IDOSA: 'Z355',
    SUPERVISAO_DE_PRIMIGESTA_MUITO_JOVEM: 'Z356',
    SUPERVISAO_NAO_ESPECIFICADA_DE_GRAVIDEZ_DE_ALTO_RISCO: 'Z359',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_ANORMALIDADE_DO_CORDAO_UMBILICAL: 'O69',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_HEMORRAGIA_INTRAPARTO_NAO_CLASSIFICADOS_EM_OUTRA_PARTE: 'O67',
    TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_SOFRIMENTO_FETAL: 'O68',
    TRABALHO_DE_PARTO_PRE_TERMO: 'O60',
    TRABALHO_DE_PARTO_PROLONGADO: 'O63',
}